import {EN} from "./en.js";

export const languages = {
  EN: EN,
  value: 'EN'
}
export const lang = languages[languages.value] || {}

